import { render, staticRenderFns } from "./keywordManage.vue?vue&type=template&id=8beb300c"
import script from "./keywordManage.vue?vue&type=script&lang=js"
export * from "./keywordManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports